import {
  setIcon,
  handleFinancialData,
  handleETFTransaction,
  handleNFT,
  handleCopyTrader,
  // 量化跟单
  handleStrategyBot,
  // Learn
  handleLearn,
  // 动态
  handleGateCommunity,
  // 直播
  handleLive,
  // 余币宝
  handleLoanData,
  // 财富管理
  handleWealthManagement,
} from "./handle_data";
import { THIS_YEAR, achievementsID, keywordID } from "./consts";
import { isValidField, generateYearKeywords, sortYearPersonilityDatas } from './tool'
import { getGenderParams } from "utils/tool";

function filterVipTitle(values) {
  const t = window.t;
  const rules = [16, 14, 9, 4];
  const rules2 = [15, 10, 5, 1];
  const textList = ["vipList4", "vipList3", "vipList2", "vipList1"];
  let vipTitle = "";
  // const values = value.replace("%", "")
  rules.forEach((i, index) => {
    rules2.forEach((j, indexJ) => {
      if (values >= rules2[indexJ] && values <= rules[index]) {
        vipTitle = t(textList[index]);
      }
    });
  });
  if (+values === 16) {
    vipTitle = t(textList[0]);
  }
  return vipTitle;
}
// 多个标题根据不同的比例大小返回对应的text
function filterTitle(
  value,
  rules = ["0-30", "30-60", "60-70", "70-100"],
  textList = [],
) {
  // const t = window.t ;
  let rules1 = [];
  let rules2 = [];
  rules.forEach((item) => {
    rules1.push(item.split("-")[1]);
    rules2.push(item.split("-")[0]);
  });
  rules1 = rules1.reverse();
  rules2 = rules2.reverse();
  const textLists = textList.reverse();
  let text = "";
  value = typeof value === "string" ? value.replace("%", "") : value;
  if (+value >= rules1[0]) {
    text = textLists[0];
    return text;
  }
  rules1.forEach((i, index) => {
    rules2.forEach((j, indexJ) => {
      if (+rules2[indexJ] <= +value && +value < +rules1[index]) {
        text = textLists[index];
      }
    });
  });

  return text;
}
export default function block_text(props) {
  const {
    // 交易
    transaction = {},
    // 实盘跟单、带单、量化跟单
    copy_order = {},
    // 社交
    social = {},
    // 用户信息
    user_info: userInfoObj = {},
  } = props;

  const {
    user_info = {},
    //用户邀请信息
    user_invite = {},
    //用户vip信息
    user_vip = {},
  } = userInfoObj;

  const {
    // 实盘跟单（带单员、跟单员、未使用）
    firm_bargain = {},
    // 量化跟单
    quantitative_trading = {},
  } = copy_order;

  const {
    //年交易量
    annual_data = {},
    //现货交易量
    spot_transaction_data = {},
    //合约交易量
    futures_transaction_data = {},
    //startup交易量
    startup_transaction_data = {},
    //NFT交易
    nft_transaction_data = {},
    //法币交易量
    c2c_transaction_data = {},
    //杠杆ETF
    etf_transaction_data = {},
    //理财宝
    financial_transaction_data = {},
    // 余币宝
    uniloan_transaction_data = {},
    // 财富管理
    wealth_transaction_data = {},
  } = transaction;

  const {
    // Learn
    learn = {},
    // 动态
    dynamic = {},
    // 直播
    live = {},
  } = social;
  // 年交易
  const {
    year_number,
    year_transaction,
    year_transaction_percentage,
    exceeded_users,
    year_last_transacation_time,
    total_profit,
    total_profit_yield,
    profit_exceeded_users,
  } = annual_data;
  const t = window.t;
  const initAreaBtnNames = [
    // 19
    t("Place of birth"),
    t("Hall of Glory"),
    t("Tree of friendship"),
    t("Annual transaction volume"),
    t("Spot never sleeps city"),
    t("Futures Fairyland"),
    t("Gate to Metaverse"),
    t("Starup, the City of Wonders"),
    t("The Great Hall of Earn"),
    // 余币宝 '稳赢之路'
    t("landlearn.nouse.title"),
    // 财富管理 '财富之门'
    t("gateway.wealth"),
    t("The Domain of Leveraged Tokens"),
    t("NFTBtn"),
    t("Strategy Bot Camp"),
    t("Copy Trading Camp"),
    t("Gate Learn Avenue"),
    t("Gate World Community"),
    t("Gate Live Town"),
    // Gate.io 丰碑
    // t('Gate.io Monument'),
    t("Invitation of the Brave"),
    // 神秘好礼
    // t('Mystery Gifts')
  ];

  // 现货数据
  const {
    exceeded_users: spotexceeded_users,
    spot_number,
    spot_transaction,
    spot_transaction_percentage,
    coin_ranking,
    valuation,
  } = spot_transaction_data;
  // 合约数据
  const {
    futures_number,
    futures_transaction,
    futures_transaction_percentage,
    exceeded_users: futures_transaction_exceeded_users,
  } = futures_transaction_data;
  // 法币交易
  const {
    c2c_number,
    c2c_transaction,
    c2c_transaction_percentage,
    exceeded_users: c2c_transaction_exceeded_users,
  } = c2c_transaction_data;
  // 理财宝
  const { greatHallofEarnTitle, greatHallofEarnText } = handleFinancialData(
    financial_transaction_data,
  );
  // starp
  const { startup_number, exceeded_users: startup_transaction_exceeded_users } =
    startup_transaction_data;
  // ETF
  const { etfTitle, etfText } = handleETFTransaction(etf_transaction_data);
  // 余币宝
  const {
    lendEarnTitle,
    lendEarnContent,
  } = handleLoanData(uniloan_transaction_data);
  // 财富管理 
  const {
    healthWealthTitle,
    healthWealthContent,
  } = handleWealthManagement(wealth_transaction_data);
  // NFT
  const { nftTitle, nftText } = handleNFT(nft_transaction_data);

  // 实盘跟单（带单、跟单、未使用)
  const { copyTraderTitle, copyTraderText } = handleCopyTrader(firm_bargain);

  // 量化跟单
  const { strategyBotTitle, strategyBotText } =
    handleStrategyBot(quantitative_trading);

  // Learn
  const { learnTitle, learnText } = handleLearn(learn);

  // 动态
  const { gateCommunityText, gateCommunityTitle } =
    handleGateCommunity(dynamic);

  // 直播
  const { liveText, liveTitle } = handleLive(live);

  // 周年庆
  const anniversaryTitle = t("anniversary_title");
  const anniversaryText = t("anniversary_text");

  const vipTitleList = [
    t("Gate.io's King of the Year1-1"),
    t("Gate.io's King of the Year1-2"),
    t("Gate.io's King of the Year1-3"),
    t("Gate.io's King of the Year1-4"),
    t("Gate.io's King of the Year1-5"),
    t("Gate.io's King of the Year1-6"),
  ];
  const vipTitleRules = ["0-30", "30-60", "60-70", "70-80", "80-90", "90-100"];
  // 标题
  // 近一年交易过  一年内无交易  从未交易
  const yearKingTitle = isValidField(year_number)
    ? filterTitle(profit_exceeded_users.replace("%", ""), vipTitleRules, vipTitleList)
    : t("Gate.io's King of the Year2");

  const SpotTransactionTitleList = [
    // t("New Entrants of Crypto"),
    // 使用"现货不夜城"
    // t('Everbright Spot City'),
    // “币圈新新人类”
    t("New Entrants of Crypto"),
    t('"Bill Gates" of Crypto World'),
    t('"Warren Buffett" of Crypto World'),
  ];
  const Rules = ["0-50", "50-80", "80-100"];

  //现货交易  title 根据比例展示  and 未使用现货
  const SpotTransactionTitle = filterTitle(
    spotexceeded_users.replace("%", ""),
    Rules,
    SpotTransactionTitleList,
  );
  const FuturesFairylandTitleList = [
    t("Outstanding Futures Expert"),
    t("Low-profile Futures Master"),
    t("The Futures Grandmaster"),
  ];
  // 合约
  const FuturesFairylandTitle =
    !isValidField(futures_number)
      ? t("futures.newbie")
      : filterTitle(
        futures_transaction_exceeded_users,
        Rules,
        FuturesFairylandTitleList,
      );
  const GateMetaverseTitleList = [
    t("Time Commando"),
    t("Time Traveler"),
    t("Time Hunter"),
  ];
  //法币交易
  const GateMetaverseTitle = isValidField(c2c_number)
    ? filterTitle(
      c2c_transaction_exceeded_users.replace("%", ""),
      Rules,
      GateMetaverseTitleList,
    )
    : t("Time Commando");
  const StarupTitleRules = ["1-3", "3-5", "5-10", "10-100"];
  const StarupTitleList = [
    t("StartupTitle1"),
    t("StartupTitle2"),
    t("StartupTitle3"),
    t("StartupTitle4"),
  ];
  const StarupTitle = isValidField(startup_number)
    ? filterTitle(startup_number, StarupTitleRules, StarupTitleList)
    : t("future.star"); //  Starup

  const titleArrfront = [
    // 17
    t("Place of birth"), // 出生地
    t("Hall of Glory"), //荣耀等级
    t("Tree of friendship"), // 邀请好友
    yearKingTitle, // 年度交易榜单
    SpotTransactionTitle, //现货交易
    FuturesFairylandTitle, // 合约交易
    GateMetaverseTitle, //Gate元宇宙之门
    StarupTitle, // StarupTitle
    // 理财宝
    greatHallofEarnTitle,
    // 新增-余币宝
    lendEarnTitle,
    // 新增-财富管理
    healthWealthTitle,
    // ETF杠杆
    etfTitle,
    // NFT
    nftTitle,
    // 量化跟单
    strategyBotTitle,
    // 实盘跟单（带单、跟单、未使用)
    copyTraderTitle,
    // Learn
    learnTitle,
    // Gate世界社区
    gateCommunityTitle,
    // live
    liveTitle,
    // Gate.io 丰碑
    // anniversaryTitle,
    // 年度关键词
    // t('year.Narrative', {
    //   thisYear: THIS_YEAR,
    // }),
  ];

  // 年度交易量（年度收益率排名） 现货交易量、 合约交易、 动态 StartUp、 理财宝、 余币宝、 Learn 财富管理、 法币交易、 量化策略、 跟单（原实盘跟单） 杠杆ETF
  // 需要将这些数据根据百分比进行排序
  const {
    prominent = '0%',
  } = learn || {};

  const gender = getGenderParams();

  const percentSortKeys = [
    // 年度交易量
    {
      title: yearKingTitle,
      percent: profit_exceeded_users,
    },
    // 现货交易量
    {
      title: SpotTransactionTitle,
      percent: spotexceeded_users,
    },
    // 合约交易
    {
      title: FuturesFairylandTitle,
      percent: futures_transaction_exceeded_users,
    },
    // 动态 StartUp
    {
      title: StarupTitle,
      percent: startup_transaction_exceeded_users,
    },
    // 理财宝
    {
      title: greatHallofEarnTitle,
      percent: financial_transaction_data.exceeded_users,
    },
    // 余币宝
    {
      title: lendEarnTitle,
      percent: uniloan_transaction_data.exceeded_users,
    },
    // Learn
    {
      title: learnTitle,
      percent: prominent,
    },
    // 财富管理
    {
      title: healthWealthTitle,
      percent: wealth_transaction_data.exceeded_users,
    },
    // 法币交易
    {
      title: GateMetaverseTitle,
      percent: c2c_transaction_exceeded_users,
    },
    // 量化策略
    {
      title: strategyBotTitle,
      percent: quantitative_trading.prominent || '0%',
    },
    // 跟单（原实盘跟单）
    {
      title: copyTraderTitle,
      percent: firm_bargain.prominent || '0%',
    },
    // 杠杆ETF
    {
      title: etfTitle,
      percent: etf_transaction_data.exceeded_users,
    },
  ]

  // 生成最终的一个形象，根据下面的数据进行排序
  // https://gtglobal.jp.larksuite.com/sheets/Cqcls2rZChfymgt2lLRjO6USpOg?sheet=wjf41U
  const yearPersonilityDatas = [
    {
      // 年度交易量
      id: 1,
      percent: exceeded_users,
      title: 'lone.wolf',
      filterCheck: user_vip.level < 1,
      // 女性、未知性别
      visible: gender !== 1,
    },
    {
      // "年度交易量超越用户百分比最高（且不为0）VIP等级1-4"
      id: 2,
      percent: exceeded_users,
      title: 'indomitable.trader',
      filterCheck: user_vip.level >= 1 && user_vip.level <= 4,
      // 男性、未知性别
      visible: gender !== 2,
    },
    {
      // "年度交易量超越用户百分比最高（且不为0）VIP等级大于等于5"
      id: 3,
      percent: exceeded_users,
      title: 'supreme.trader',
      filterCheck: user_vip.level >= 5,
      // 男性、未知性别
      visible: gender !== 2,
    },
    {
      // "年度总收益超越用户百分比最高（且不为0）VIP等级小于1"
      id: 4,
      percent: profit_exceeded_users,
      title: 'budding.trader',
      filterCheck: user_vip.level < 1,
      // 男性、未知性别
      visible: gender !== 2,
    },
    {
      // "年度总收益超越用户百分比最高（且不为0）VIP等级1-4"
      id: 5,
      percent: profit_exceeded_users,
      title: 'dauntless.trader',
      filterCheck: user_vip.level >= 1 && user_vip.level <= 4,
      // 男性、未知性别
      visible: gender !== 2,
    },
    {
      // "年度总收益超越用户百分比最高（且不为0）VIP等级大于等于5"
      id: 6,
      percent: profit_exceeded_users,
      title: 'invincible.trader',
      filterCheck: user_vip.level >= 5,
      // 男性、未知性别
      visible: gender !== 2,
    },
    {
      // 杠杆ETF
      id: 7,
      percent: etf_transaction_data.exceeded_users,
      title: 'realistic.commander',
      filterCheck: true,
      // 男性、未知性别
      visible: gender !== 2,
    },
    {
      // 合约交易
      id: 8,
      percent: futures_transaction_exceeded_users,
      title: 'perfect.thinker',
      filterCheck: true,
      // 女性、未知性别
      visible: gender !== 1,
    },
    {
      // 现货交易量
      id: 9,
      percent: spotexceeded_users,
      title: 'versatile.maverick',
      filterCheck: user_vip.level < 1,
      // 男性、未知性别
      visible: gender !== 2,
    },
    {
      // "现货-超越用户百分比最高（且不为0）VIP等级1-4（包含1）"
      id: 10,
      percent: spotexceeded_users,
      title: 'discerning.pioneer',
      filterCheck: user_vip.level >= 1 && user_vip.level <= 4,
      // 男性、未知性别
      visible: gender !== 2,
    },
    {
      // "现货-超越用户百分比最高（且不为0）VIP等级大于等于5"
      id: 11,
      percent: spotexceeded_users,
      title: 'insightful.intellectual',
      filterCheck: user_vip.level >= 5,
      // 男性、未知性别
      visible: gender !== 2,
    },
    {
      // 现货-超越用户百分比最高（且不为0）
      id: 12,
      percent: spotexceeded_users,
      title: 'visionary.spotElite',
      filterCheck: true,
      // 女性、未知性别
      visible: gender !== 1,
    },
    {
      // 法币交易
      id: 13,
      percent: c2c_transaction_exceeded_users,
      title: 'resourceful.strategist',
      filterCheck: true,
      // 男性、未知性别
      visible: gender !== 2,
    },
    {
      // 余币宝
      id: 13,
      percent: uniloan_transaction_data.exceeded_users,
      title: 'resourceful.strategist',
      filterCheck: true,
      // 男性、未知性别
      visible: gender !== 2,
    },
    {
      // 理财宝 
      id: 13,
      percent: financial_transaction_data.exceeded_users,
      title: 'resourceful.strategist',
      filterCheck: true,
      // 男性、未知性别
      visible: gender !== 2,
    },
    {
      // Learn
      id: 14,
      percent: prominent,
      title: 'intelligent.researcher',
      filterCheck: true,
      // 男性、未知性别
      visible: gender !== 2,
    },
    {
      // 跟单（原实盘跟单）跟单员超越用户百分比最高（且不为0）
      id: 15,
      percent: firm_bargain.prominent || '0%',
      title: 'keen.observer',
      // 跟单
      filterCheck: firm_bargain.user_type === 2,
      // 男性、未知性别
      visible: gender !== 2,
    },
    {
      // start up
      id: 16,
      percent: startup_transaction_exceeded_users,
      title: 'great.visionary',
      filterCheck: true,
      // 女性、未知性别
      visible: gender !== 1,
    },
    {
      // 跟单（原实盘跟单）带单员超越用户百分比最高（且不为0）
      id: 17,
      percent: firm_bargain.prominent || '0%',
      title: 'natural.leader',
      // 带单
      filterCheck: firm_bargain.user_type === 1,
      // 男性、未知性别
      visible: gender !== 2,
    },
    {
      // 量化
      id: 17,
      percent: quantitative_trading.prominent || '0%',
      title: 'natural.leader',
      filterCheck: true,
      // 男性、未知性别
      visible: gender !== 2,
    },
    {
      // 财富管理
      id: 17,
      percent: wealth_transaction_data.exceeded_users,
      title: 'natural.leader',
      filterCheck: true,
      // 男性、未知性别
      visible: gender !== 2,
    },
    {
      // 动态
      id: 18,
      percent: dynamic.prominent || '0%',
      title: 'lively.diplomat',
      filterCheck: true,
      // 女性、未知性别
      visible: gender !== 1,
    },
  ]
  // 年度形象默认值
  const yearPersonilityDefaults = [
    {
      // 所有模块均未使用、VIP等级大于等于1
      id: 19,
      // 如果是男性，直接返回true
      filterCheck: gender === 1 ? true : user_vip.level >= 1,
      title: 'sagacious.adventurer',
      // 男性、未知性别
      visible: gender !== 2,
    },
    {
      // "所有模块均未使用、VIP等级小于1
      id: 20,
      filterCheck: gender === 2 ? true : user_vip.level < 1,
      title: 'free.spirit',
      // 女性、未知性别
      visible: gender !== 1,
    },
  ]

  // 年度关键词
  const sortedYearKeywords = generateYearKeywords(percentSortKeys, coin_ranking)
  // 年度形象，共有十六个形象，根据百分比和vip等级算出一个形象
  const sortedYearPersonilityDatas = sortYearPersonilityDatas(yearPersonilityDatas, yearPersonilityDefaults)

  const titleArr = [
    ...titleArrfront,
    // 分享区块
    [...titleArrfront],
    // 神秘小礼的文案在内部处理，不涉及分享
  ];

  // 注册时间相关
  const { register_rank, first_trade_time, register_time, visit_bill_rank } =
    user_info;
  //vip等级
  const { level, reduce_fee } = user_vip;
  // 邀请人
  const { invite_number } = user_invite;

  const transaction_typeList = {
    1: t("Everbright Spot City"),
    2: t("Futures Fairyland"),
    3: t("Gate to Metaverse"),
    4: t("Starup, the City of Wonders"),
    5: t("The Great Hall of Earn"),
    6: t("The Domain of Leveraged Tokens"),
    7: t("NFT Magical World"),
    8: t("Strategy Bot Camp"),
    9: t("Copy Trading Camp"),
  };

  //出生地
  const PlaceOfBirth = first_trade_time.year
    ? `<p class='mb-12'>${t("PlaceOfBirth1-1", {
      month: register_time.month,
      day: register_time.day,
      year: register_time.year,
      orderNum: register_rank,
    })}</p><p class='mb-12'>${t("PlaceOfBirth1-2", {
      month: first_trade_time.month,
      day: first_trade_time.day,
      year: first_trade_time.year,
      USDT: first_trade_time.transaction_amount,
      type: transaction_typeList[first_trade_time.transaction_type] || "",
    })}</p> ${t("placeOfBirth1-3")}`
    : `<p class='mb-12'>${t("PlaceOfBirth1-1", {
      month: register_time.month,
      day: register_time.day,
      year: register_time.year,
      orderNum: register_rank,
    })}</p>${t("PlaceOfBirth2-2")}`;
  //vip
  const vipText =
    Number(reduce_fee) > 0
      ? `<p class='mb-12'>${t("Hall_of_Glory1-1", {
        VIPGrade: level,
        platinum: filterVipTitle(level),
      })}</p>${t("Hall_of_Glory1-2", {
        USDT: reduce_fee,
        thisYear: THIS_YEAR,
      })}`
      : t("Hall_of_Glory2-1");
  // 邀请朋友
  const friendshipTree = isValidField(invite_number)
    ? `${t("friendshipTree1-1", {
      num: invite_number,
      thisYear: THIS_YEAR,
    })}${t("friendshipTree1-2")}`
    : `<p class='mb-12'>${t("friendshipTree2-1")}</p>${t("friendshipTree2-2")}`;
  // 年交易  近一年交易过  一年内无交易  从未交易
  const AnnualTransactionVolume = isValidField(year_number)
    ? `<p class='mb-12'>${t("AnnualTransactionVolume1-1", {
      order: year_number,
      thisYear: THIS_YEAR,
    })}</p>${t("AnnualTransactionVolume1-2-fixed", {
      USDT: year_transaction,
      icon1: setIcon(year_transaction_percentage),
      Exceed: exceeded_users,
    })}<p>${t("AnnualTransactionVolumeTotalIncome", {
      USDT: total_profit,
      icon: setIcon(total_profit_yield),
      Exceed: profit_exceeded_users,
    })}</p>`
    : year_last_transacation_time
      ? `<p class='mb-12'>${t("AnnualTransactionVolume2-1", {
        dayNum: year_last_transacation_time,
        thisYear: THIS_YEAR,
      })}</p>${t("AnnualTransactionVolume2-2")}`
      : `${t("AnnualTransactionVolume3")}`;
  // 现货
  const SpotTransactionText = isValidField(spot_number)
    ? `<p class='mb-12'>${t("SpotTransactionText1-1", {
      order: spot_number,
      USDT: spot_transaction,
      Exceed: spotexceeded_users,
      icon: setIcon(spot_transaction_percentage),
    })}</p>${t("SpotTransactionText1-2", {
      Currency: coin_ranking,
      orderNum: valuation,
      thisYear: THIS_YEAR,
    })}</p>`
    : t("SpotTransactionText2");
  // 合约
  const FuturesFairylandText = isValidField(futures_number)
    ? `<p class='mb-12'>${t("FuturesFairylandText1-1", {
      orderNum: futures_number,
      USDT: futures_transaction,
      Exceed: futures_transaction_exceeded_users,
    })}</p>${t("FuturesFairylandText1-2", {
      Exceed: futures_transaction_percentage,
      icon: "",
      thisYear: THIS_YEAR,
    })}`
    : t("FuturesFairylandText2");
  //法币交易
  const GateMetaverseText = isValidField(c2c_number)
    ? t("GateMetaverseTitle1", {
      orderNum: c2c_number,
      num: `$ ${c2c_transaction}`,
      Exceed: c2c_transaction_exceeded_users,
      icon: setIcon(c2c_transaction_percentage),
    })
    : t("GateMetaverseTitle2");

  const StarupText = isValidField(startup_number)
    ? `<p class='mb-12'>${t("StartupText1-1", {
      num: startup_number,
      Exceed: startup_transaction_exceeded_users,
    })}</p>${t("StartupText1-2")}`
    : t("StartupText2");

  const textArrFront = [
    // 17
    PlaceOfBirth, // 出生地
    vipText, //vip等级
    friendshipTree, // 邀请好友
    AnnualTransactionVolume, // 交易榜单
    SpotTransactionText, //现货交易
    FuturesFairylandText, // 合约交易
    GateMetaverseText, //法币交易
    StarupText,
    // PlaceOfBirth,
    // vipText,
    // 理财宝
    greatHallofEarnText,
    // 新增-余币宝
    lendEarnContent,
    // 新增-财富管理
    healthWealthContent,
    // ETF
    etfText,
    // NFT
    nftText,
    // 量化跟单
    strategyBotText,
    // 实盘跟单（带单、跟单、未使用)
    copyTraderText,
    // Learn
    learnText,
    // 动态
    gateCommunityText,
    // live
    liveText,
    // anniversary
    // anniversaryText,
  ];

  // text
  const textArr = [
    ...textArrFront,
    // 分享区块
    [...textArrFront],
    // 神秘小礼的文案在内部处理，不涉及分享
  ];

  const initArea = [];
  // id为19的保留吧，这是之前的神秘好礼
  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 20, 21].forEach(
    (i, index) => {
      let imgSrc = require(`../assets/img/Checkpoint${index + 1}.png`);
      const detailsObj = {
        id: i,
        URL: imgSrc,
        btnName: initAreaBtnNames[index],
        text: textArr[index],
        title: titleArr[index] || "",
        notHasLawsTips: [21].includes(i),
      };
      if (i === achievementsID) {
        initArea.push({
          ...detailsObj,
          visit_bill_rank: visit_bill_rank,
        });
      } else if (i === keywordID) {
        initArea.push({
          ...detailsObj,
          keywords: sortedYearKeywords,
          personality: sortedYearPersonilityDatas,
        });
      } else {
        initArea.push({
          ...detailsObj,
        });
      }
    },
  );

  return initArea;
}
